import { httpClient } from './client';

import type { Country, State, Timezone } from '../types/reference-data';

/**
 * Fetch countries reference data
 */
export const getCountries = async (): Promise<Country[]> => {
  const response = await httpClient.get('/reference/country');
  return response?.data ?? [];
};

/**
 * Fetch states/provinces reference data
 */
export const getStates = async (): Promise<State[]> => {
  const response = await httpClient.get('/reference/state');
  return response?.data ?? [];
};

/**
 * Fetch available IANA timezones
 */
export const getTimezones = async (): Promise<Timezone[]> => {
  const response = await httpClient.get('/timezone', {
    params: { useOnlyLegacySupportedTimeZones: true },
  });
  return response?.data ?? [];
};
